export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
